import { render, staticRenderFns } from "./pluginList.vue?vue&type=template&id=5afb06eb"
import script from "./pluginList.vue?vue&type=script&lang=js"
export * from "./pluginList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports